export default __webpack_public_path__ + "static/media/paribas-fortis.021e9b1d.png";